import { graphneAPI } from './graphneAPI';

export const useGraphneAPI = () => graphneAPI;
